export const GET_CATEGORY_BEGIN = 'get_category_begin';
export const GET_CATEGORY_REQUESTING = 'get_category_requesting';
export const GET_CATEGORY_SUCCESS = 'get_category_success';
export const GET_CATEGORY_ERROR = 'get_category_error';